var _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "666.95 150.27 657.38 196.62 651.22 190.61 640.74 198.09 632.73 188.14 614.77 201.2 599.42 175.53 582.3 185.56 575.51 176.2 553.77 188.45 547.23 174.44 562.47 100.63 644.17 117.5 666.95 150.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.17 117.5 666.95 150.27 638.61 144.42 644.17 117.5",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "655.34 205.88 641.31 273.88 531.26 251.16 545.19 183.71 551.73 197.71 573.48 185.46 580.26 194.82 597.39 184.8 612.73 210.47 630.7 197.41 638.7 207.35 649.19 199.88 655.34 205.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.83 197.91 385.68 204.85 376.77 60.89 460.05 55.73 490.62 81.38 497.83 197.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.05 55.73 490.62 81.38 461.74 83.17 460.05 55.73",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,152.6l-.44-3.25c-1.13-6.73.71-14.26,6.56-22.13,5.28-7,8.14-12,7.82-17.68-.36-6.4-4.61-10.44-12.52-10.12a22.31,22.31,0,0,0-12.45,4.6l-3.45-7.73c4-3.25,11-5.65,17.65-6,14.43-.8,21.45,7.74,22,17.27.48,8.53-3.94,14.94-9.56,22.43-5.16,6.83-6.85,12.46-6.12,18.83l.31,3.26Zm-1.78,17.71c-.26-4.64,2.69-8.08,7.08-8.32s7.59,2.84,7.85,7.49c.24,4.39-2.45,7.93-7.09,8.19C430.63,177.92,427.43,174.7,427.18,170.31Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.48,128.11,137.2,123l-1.57,3.45a3,3,0,0,1-2.57,1.72,14.48,14.48,0,0,0-1.85.18,3,3,0,0,1-2.85-1.18l-2.21-3.09-10.07,7.22,2.21,3.09a3,3,0,0,1,.2,3.07,18.29,18.29,0,0,0-.77,1.69,3,3,0,0,1-2.45,1.89l-3.77.37,1.21,12.33,3.79-.38a3,3,0,0,1,2.77,1.38c.16.26.33.51.51.76s.36.49.55.73a2.94,2.94,0,0,1,.42,3.05l-1.58,3.48,11.29,5.12,1.57-3.47a3,3,0,0,1,2.58-1.71,16.19,16.19,0,0,0,1.83-.18,3,3,0,0,1,2.85,1.18l2.21,3.09,10.08-7.22-2.21-3.09a2.91,2.91,0,0,1-.2-3.07,17.94,17.94,0,0,0,.75-1.68,2.94,2.94,0,0,1,2.45-1.89l3.79-.38-1.22-12.33-3.79.37a2.94,2.94,0,0,1-2.75-1.37c-.17-.26-.34-.51-.52-.76s-.36-.5-.55-.73a3,3,0,0,1-.42-3.07Zm-6.4,11.41a10.15,10.15,0,1,1-14.16-2.34A10.15,10.15,0,0,1,142.08,139.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.38,291.71l-7.52,4.34,1.33,2.3a2,2,0,0,1-.07,2.17c-.23.36-.45.73-.65,1.12a2,2,0,0,1-1.83,1.14H647v8.69h2.66a2,2,0,0,1,1.83,1.14c.2.39.42.76.65,1.12a2,2,0,0,1,.07,2.17l-1.33,2.3,7.52,4.34,1.34-2.31a2.05,2.05,0,0,1,1.91-1h1.28a2.06,2.06,0,0,1,1.91,1l1.34,2.32,7.51-4.34-1.33-2.31a2.05,2.05,0,0,1,.08-2.16c.23-.36.45-.74.65-1.12a2,2,0,0,1,1.83-1.14h2.66v-8.69H674.9a2,2,0,0,1-1.83-1.14c-.2-.38-.42-.76-.65-1.12a2.05,2.05,0,0,1-.08-2.16l1.33-2.31-7.51-4.34L664.82,294a2.05,2.05,0,0,1-1.91,1l-.64,0-.64,0a2.08,2.08,0,0,1-1.92-1Zm3.89,8.3a7.12,7.12,0,1,1-7.11,7.11A7.11,7.11,0,0,1,662.27,300Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3,91.16l-6.89,5.28L166,98.55a2,2,0,0,1,.21,2.15,10.47,10.47,0,0,0-.5,1.2,2.05,2.05,0,0,1-1.67,1.37l-2.64.34,1.12,8.61,2.64-.34a2.06,2.06,0,0,1,2,.9,11.14,11.14,0,0,0,.78,1,2,2,0,0,1,.36,2.13l-1,2.46,8,3.33,1-2.46a2.05,2.05,0,0,1,1.77-1.25l.64-.07.63-.1a2.06,2.06,0,0,1,2,.75l1.63,2.13,6.89-5.28-1.61-2.11a2.06,2.06,0,0,1-.21-2.16,11.12,11.12,0,0,0,.5-1.19,2.05,2.05,0,0,1,1.67-1.37l2.64-.34-1.12-8.61-2.64.34a2.06,2.06,0,0,1-2-.89c-.25-.36-.51-.7-.79-1A2.07,2.07,0,0,1,186,96l1-2.46-8-3.33-1,2.46a2.07,2.07,0,0,1-1.77,1.25l-.64.06L175,94a2.06,2.06,0,0,1-2-.75Zm4.93,7.73a7.11,7.11,0,1,1-6.14,8A7.11,7.11,0,0,1,176.23,98.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.82,316.78a275.64,275.64,0,0,0-.4-29,370.79,370.79,0,0,0-9.09-59.16c-2.54-10.94-5.66-21.7-8.92-32.45-.1-.33-.62-.24-.53.1,10.07,37.9,18.33,77,17.76,116.4-.16,11-1.44,21.85-2.48,32.81,0,.29.45.41.52.11C118.75,336.18,119.43,326.36,119.82,316.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.88,196.24S85.64,234.94,89.05,244s10.45,11,10.45,11-9.33,13.32-2.81,25.81,21,11.9,22,26.06C118.66,306.94,119.46,247.73,100.88,196.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,282.49a.28.28,0,0,0,0-.2,354.31,354.31,0,0,0-14.78-77.85c0-.07-.15-.05-.13,0q4.53,17,8,34.14a16.87,16.87,0,0,0-7.28-4.06s-.08.06,0,.08a19.35,19.35,0,0,1,7.52,5c.44,2.25.88,4.49,1.29,6.74-3.41-3.81-8.13-5.7-12.86-7.5a.06.06,0,0,0,0,.11c4.93,2,9.83,4.58,13.17,8.83q1.74,9.63,3.06,19.33a18.43,18.43,0,0,0-9.09-5.21c-.11,0-.17.13-.06.16A19.16,19.16,0,0,1,115,268l.06,0q.45,3.4.86,6.83a23.37,23.37,0,0,0-6.37-3.84c-.06,0-.1.07,0,.09a21.89,21.89,0,0,1,6.39,4.23s.05,0,.08,0c.25,2.17.5,4.34.72,6.51a31,31,0,0,0-12.93-9.24.08.08,0,0,0,0,.16,33.68,33.68,0,0,1,12.74,9.81.3.3,0,0,0,.32.1c.33,3.33.63,6.66.87,10,0,.05.08.05.08,0Q117.43,287.62,117,282.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75,230.71a19.09,19.09,0,0,0-9.16-2.86.06.06,0,0,0,0,.12,36.16,36.16,0,0,1,9.06,3C104.77,231,104.86,230.79,104.75,230.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.6,271.68a19.06,19.06,0,0,0-6.88-2.35c-.08,0-.09.11,0,.13a26.05,26.05,0,0,1,6.8,2.38C106.61,271.89,106.69,271.73,106.6,271.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,244.67a103.7,103.7,0,0,0-17.65,15.42,63.19,63.19,0,0,0-12.37,21,156.93,156.93,0,0,0-9.22,50.2,122.32,122.32,0,0,0,2.71,28.23.27.27,0,0,0,.53-.1,158.6,158.6,0,0,1,.28-49.35c2.62-16,6.73-33.42,16.91-46.43,5.54-7.09,12.45-12.66,19.28-18.42C160.73,244.9,160.27,244.41,159.9,244.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.9,319.75a95,95,0,0,1,12.86-16.44c7.63-7.63,14.05-13.05,15.05-18.09s-7.64-8.76-7.64-8.76,10.55,1.9,13.44-2.53,4.28-30.09,4.28-30.09-19.2,13.71-28.15,32.93S122.9,319.75,122.9,319.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.25,250.42c-8.08,7.93-16.21,16.39-21,26.82A102.83,102.83,0,0,0,129,288.29v0c-.24.76-.49,1.52-.72,2.28a.19.19,0,0,0,0,.12,218.27,218.27,0,0,0-5.46,23.71c0,.05.07.07.08,0,.83-4,1.74-8,2.76-12.07a.27.27,0,0,0,.12,0,17.14,17.14,0,0,1,5-1.28c.11,0,.1-.21,0-.2a18.78,18.78,0,0,0-5,.91c.93-3.63,1.94-7.26,3.08-10.83a53.32,53.32,0,0,1,11.39-1.49,0,0,0,0,0,0-.06,43,43,0,0,0-11.2.95c.2-.61.41-1.22.61-1.83a59.12,59.12,0,0,1,7.58-1.29s0-.08,0-.08a37,37,0,0,0-7.42.9c1-3.09,2.17-6.14,3.42-9.1a55,55,0,0,1,3.63-7,45.52,45.52,0,0,1,6.15-1.1s0-.1,0-.1a16.67,16.67,0,0,0-5.75.57c1-1.63,2.07-3.23,3.21-4.78h0c4.31-.95,8.67-1.84,13.08-1a.07.07,0,0,0,0-.13c-4.19-1.11-8.35-.47-12.52.35.45-.6.92-1.2,1.39-1.79a28.43,28.43,0,0,1,8-1.27,0,0,0,0,0,0-.09,21.09,21.09,0,0,0-7.5.67c3.56-4.42,7.49-8.58,11.38-12.69C154.58,250.34,154.44,250.23,154.25,250.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,267.91a16.84,16.84,0,0,0-3.82-.13c-.15,0-.14.26,0,.27,1.26,0,2.53-.06,3.79,0A.08.08,0,0,0,154,267.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.21,292.8a17.2,17.2,0,0,0-5.92,1.18s0,.1,0,.09c2-.47,3.93-.66,5.91-1A.15.15,0,0,0,140.21,292.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.07,284.2a13.23,13.23,0,0,0-2.51.22.08.08,0,0,0,0,.15,12.39,12.39,0,0,0,2.51-.11A.13.13,0,0,0,136.07,284.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.61,271.89a87.15,87.15,0,0,1,17.85,8.41,53.33,53.33,0,0,1,14.87,14.12,132.2,132.2,0,0,1,19.06,38.49,102.52,102.52,0,0,1,4.32,23.48.23.23,0,0,1-.45,0,133.21,133.21,0,0,0-11.62-39.87c-5.83-12.35-13.18-25.49-24.42-33.67-6.12-4.45-13-7.37-19.86-10.45C66,272.28,66.25,271.77,66.61,271.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.91,324.1A80.28,80.28,0,0,0,99.7,313.77c-7.94-4.41-14.39-7.31-16.36-11.16s4.16-8.85,4.16-8.85-8.1,4-11.46,1.05-10.42-23.35-10.42-23.35S84.33,278.11,96,291.6,113.91,324.1,113.91,324.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.93,319.89C103.58,302.33,91.09,286.44,74,276h0a86.26,86.26,0,0,1,12.52,9.8,19.88,19.88,0,0,0-10.06,2.12.06.06,0,0,0,0,.11,27.5,27.5,0,0,1,10.35-1.75.25.25,0,0,0,.12,0c.61.57,1.2,1.16,1.8,1.75a31.46,31.46,0,0,0-5.38.71s0,.08,0,.08a27,27,0,0,1,5.67-.47,116.91,116.91,0,0,1,8.83,10,8.84,8.84,0,0,0-3.76.27.07.07,0,1,0,0,.14,19.92,19.92,0,0,1,4-.05c.51.65,1,1.3,1.53,2a35.87,35.87,0,0,0-11.35,1.1c-.06,0,0,.1,0,.09A45.65,45.65,0,0,1,100,301c.48.63.93,1.28,1.4,1.92a24.56,24.56,0,0,0-6.76.78.07.07,0,0,0,0,.13,26.09,26.09,0,0,1,7-.54c2,2.77,3.94,5.61,5.79,8.47a6.36,6.36,0,0,0-3,.18,0,0,0,0,0,0,.08,13.26,13.26,0,0,1,3.21.16q2.5,3.88,4.82,7.85C112.7,320.29,113.06,320.12,112.93,319.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.38,305.32a14.35,14.35,0,0,0-5.44.67s0,.09,0,.08a40.82,40.82,0,0,1,5.41-.56C98.48,305.51,98.51,305.33,98.38,305.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.06,283.92a9.19,9.19,0,0,0-2.51.14c-.09,0-.06.16,0,.15.83-.09,1.64-.06,2.46-.08A.11.11,0,0,0,82.06,283.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.04 382.18 95.81 382.18 101.83 338.07 103.37 326.76 130.48 326.76 132.02 338.07 138.04 382.18",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.02 338.07 101.83 338.07 103.37 326.76 130.48 326.76 132.02 338.07",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.49,
    y: 322.84,
    width: 34.86,
    height: 9.58,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-65"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 425.29,
    rx: 286.74,
    ry: 31.42,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "576.32 432.05 271.64 432.05 315.69 182.2 620.37 182.2 576.32 432.05",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.97 156.32 320.26 156.32 315.69 182.2 422.4 182.2 419.97 156.32",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "576.32 432.05 271.64 432.05 315.69 182.2 620.37 182.2 576.32 432.05"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.97 156.32 320.26 156.32 315.69 182.2 422.4 182.2 419.97 156.32"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M309.5,166.88a19.17,19.17,0,0,1,0-8.7,19.17,19.17,0,0,1,0,8.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.64,169.44a17,17,0,0,1-2.61-3.52,17.35,17.35,0,0,1-1.75-4,16.58,16.58,0,0,1,2.61,3.51A17.61,17.61,0,0,1,300.64,169.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.24,176.09a19.18,19.18,0,0,1-7.53-4.35,17.16,17.16,0,0,1,4,1.74A17.58,17.58,0,0,1,294.24,176.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,185.05a19.17,19.17,0,0,1-8.7,0,19.17,19.17,0,0,1,8.7,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.6,193.91a17.64,17.64,0,0,1-3.52,2.61,17.16,17.16,0,0,1-4,1.74,17,17,0,0,1,3.52-2.61A16.8,16.8,0,0,1,294.6,193.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.24,200.3a19.13,19.13,0,0,1-4.35,7.54,16.83,16.83,0,0,1,1.75-4A17.31,17.31,0,0,1,301.24,200.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.2,202.51a17.45,17.45,0,0,1,.5,4.35,17,17,0,0,1-.5,4.35,16.57,16.57,0,0,1-.5-4.35A17.45,17.45,0,0,1,310.2,202.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.06,200a17,17,0,0,1,2.61,3.52,16.8,16.8,0,0,1,1.74,4,19.13,19.13,0,0,1-4.35-7.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.45,193.3a16.8,16.8,0,0,1,4,1.74,17,17,0,0,1,3.52,2.61,16.8,16.8,0,0,1-4-1.74A17,17,0,0,1,325.45,193.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.66,184.34a19.22,19.22,0,0,1,8.71,0,19.22,19.22,0,0,1-8.71,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.1,175.48a17.31,17.31,0,0,1,3.52-2.6,16.44,16.44,0,0,1,4-1.75,19.13,19.13,0,0,1-7.54,4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.45,169.09a17.58,17.58,0,0,1,1.74-4,17,17,0,0,1,2.61-3.52,16.8,16.8,0,0,1-1.74,4A17,17,0,0,1,318.45,169.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "575.87 432.05 270.54 432.05 227.18 191.27 532.52 191.27 575.87 432.05",
    style: {
      fill: "#B0BEC5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.99,
    cy: 325.77,
    r: 12.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.31,
    cy: 325.77,
    r: 12.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.38,340.49l-.7-1.33c-.06-.12-6.62-12.24-19.81-12.24-12,0-15,11.41-15.08,11.9l-.36,1.45-2.91-.7.35-1.46c0-.14,3.58-14.19,18-14.19,15,0,22.17,13.28,22.47,13.85l.7,1.32Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fly--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.71,324.8l-.21-1c.65-.14,1.29-.29,1.93-.46l.25,1C557,324.51,556.37,324.66,555.71,324.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.55,323.19l-.32-.94c1.25-.43,2.5-.9,3.71-1.41l.39.92C564.1,322.28,562.83,322.76,561.55,323.19ZM569,320l-.45-.88c1.17-.61,2.34-1.27,3.45-2l.52.85C571.38,318.76,570.19,319.43,569,320Zm6.88-4.23-.59-.81c1.08-.79,2.12-1.62,3.1-2.47l.66.75C578,314.15,577,315,575.87,315.81Zm6.1-5.32-.73-.69c.92-1,1.79-2,2.59-3l.79.61C583.8,308.47,582.91,309.5,582,310.49Zm4.95-6.4-.85-.53a29.08,29.08,0,0,0,1.84-3.48l.92.41A33.74,33.74,0,0,1,586.92,304.09Zm3.31-7.42-1-.28a26.14,26.14,0,0,0,.81-3.83l1,.13A25.66,25.66,0,0,1,590.23,296.67Zm1.11-8h-1v-.29c0-1.21-.07-2.44-.19-3.65l1-.1a36.24,36.24,0,0,1,.2,3.75Zm-1.8-7.83a39.3,39.3,0,0,0-1-3.82l1-.3c.41,1.3.76,2.62,1,3.91Zm-2.37-7.53c-.48-1.18-1-2.39-1.64-3.61l.9-.45c.61,1.24,1.17,2.48,1.66,3.68Zm-3.5-7.13c-.62-1.09-1.3-2.24-2-3.42l.85-.53c.73,1.19,1.42,2.35,2,3.46Zm-4.18-6.79c-.73-1.1-1.47-2.21-2.23-3.32l.83-.56c.76,1.11,1.5,2.22,2.23,3.34ZM575,252.73c-.75-1.1-1.51-2.21-2.25-3.31l.83-.56c.74,1.1,1.49,2.21,2.24,3.3Zm-4.47-6.66c-.73-1.12-1.44-2.26-2.14-3.4l.85-.52c.7,1.14,1.41,2.26,2.13,3.38Zm-4.17-6.87c-.68-1.21-1.31-2.41-1.88-3.56l.9-.45c.56,1.14,1.19,2.32,1.85,3.52ZM562.81,232c-.53-1.25-1-2.52-1.44-3.76l1-.32c.42,1.21.89,2.46,1.41,3.69Zm-2.6-7.63c-.33-1.3-.62-2.63-.84-4l1-.16c.22,1.28.49,2.58.82,3.86Zm-1.34-8c-.1-1.23-.15-2.47-.15-3.71v-.33h1v.32c0,1.21,0,2.43.15,3.63Zm1-8-1-.1c0-.27.05-.55.08-.84.12-1.07.27-2.14.45-3.16l1,.17c-.17,1-.32,2.05-.44,3.1C560,207.85,560,208.12,559.92,208.4Zm1.39-7.78-1-.27c.37-1.32.8-2.61,1.28-3.84l.93.36A36.6,36.6,0,0,0,561.31,200.62Zm49.83-5.83c-.56,0-1.14-.08-1.71-.16-.78-.11-1.56-.24-2.33-.39l.2-1c.74.14,1.51.27,2.27.38.54.07,1.09.12,1.62.15Zm4.11-.31-.21-1a11.54,11.54,0,0,0,3.56-1.38l.52.85A12.45,12.45,0,0,1,615.25,194.48Zm-51.06-1.19-.89-.47a35.46,35.46,0,0,1,2.11-3.46l.82.57A32.66,32.66,0,0,0,564.19,193.29Zm39-.06a38.51,38.51,0,0,1-3.8-1.43l.41-.92a34.09,34.09,0,0,0,3.69,1.39Zm19-3.12-.83-.56a7,7,0,0,0,1.22-3.49l1,.07A8,8,0,0,1,622.17,190.11Zm-26.4-.15a36.69,36.69,0,0,1-3.39-2.23l.59-.8a35.28,35.28,0,0,0,3.3,2.16Zm-27.1-3.12-.74-.67a33.81,33.81,0,0,1,2.89-2.85l.66.75A33.41,33.41,0,0,0,568.67,186.84Zm20.59-1.69a37,37,0,0,1-2.83-2.91l.75-.66a36.84,36.84,0,0,0,2.75,2.83Zm32.55-2.71a9.77,9.77,0,0,0-2.33-3l.66-.75a10.8,10.8,0,0,1,2.57,3.29Zm-47.22-.79-.57-.82a38.58,38.58,0,0,1,3.47-2.11l.47.88A37.77,37.77,0,0,0,574.59,181.65Zm9.34-2.6c-.38-.54-.75-1.09-1.1-1.66l-1.3.51-.38-.92,1.15-.46c-.18-.3-.36-.6-.53-.9l.87-.49c.2.35.4.7.61,1q.84-.3,1.71-.57l.29,1c-.49.15-1,.31-1.46.48.31.49.63,1,1,1.43Zm32.33-1.72a21.3,21.3,0,0,0-3-1.22l-.66-.21.29-1,.68.22a21.6,21.6,0,0,1,3.12,1.27Zm-27.18-1.79-.21-1c1.29-.29,2.63-.53,4-.72l.15,1C591.67,175,590.36,175.25,589.08,175.54Zm19.7-.54c-1.25-.22-2.57-.39-3.92-.51l.08-1c1.39.12,2.74.29,4,.52Zm-11.85-.58-.07-1c1.19-.07,2.38-.11,3.56-.11h.49v1h-.48C599.27,174.31,598.09,174.34,596.93,174.42ZM580,172c-.54-1.22-1-2.49-1.45-3.78l1-.31c.42,1.26.89,2.5,1.41,3.69Zm-2.53-7.68c-.3-1.29-.55-2.63-.74-4l1-.14c.19,1.32.43,2.63.72,3.9Zm-1.12-8c-.05-.9-.08-1.82-.08-2.74,0-.43,0-.87,0-1.3l1,0c0,.43,0,.85,0,1.28,0,.9,0,1.81.07,2.68Zm1.19-8-1-.1c.14-1.32.33-2.67.56-4l1,.17C577.83,145.72,577.64,147,577.51,148.34Zm1.37-7.81-1-.24c.32-1.29.69-2.59,1.1-3.89l1,.31C579.56,138,579.19,139.27,578.88,140.53Zm2.4-7.57-.93-.36c.49-1.25,1-2.5,1.61-3.71l.9.44C582.29,130.51,581.76,131.73,581.28,133Zm3.44-7.13-.87-.51c.68-1.15,1.41-2.3,2.17-3.4l.82.57C586.09,123.57,585.38,124.69,584.72,125.83Zm4.51-6.51-.78-.63c.84-1,1.74-2.06,2.67-3l.72.69C590.93,117.3,590.05,118.3,589.23,119.32Zm5.44-5.76-.67-.74c1-.89,2-1.77,3.07-2.62l.62.79C596.65,111.82,595.63,112.69,594.67,113.56Zm6.21-4.94-.57-.83c1.09-.75,2.23-1.49,3.39-2.19l.51.85C603.08,107.14,602,107.87,600.88,108.62Zm6.79-4.13-.47-.88c1.18-.63,2.4-1.23,3.62-1.79l.42.91C610,103.28,608.83,103.88,607.67,104.49Zm7.23-3.32-.37-.94c1.26-.49,2.53-1,3.79-1.37l.32,1C617.4,100.22,616.14,100.68,614.9,101.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.64,98.62l-.25-1c1.24-.32,2-.46,2-.46l.18,1S623.85,98.31,622.64,98.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.32,92.16c-2.55-7.9-19.63-5.06-16.3,5.27S642.87,100.07,640.32,92.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.73,89c.13-3.47,4.95-6.14,11.77-4.91s13.23,5.83,13.23,5.83S633,94,626.11,94.75,614.6,92.46,614.73,89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.73,89.9c-3.54,0-7.07-.1-10.6-.21s-7.07-.29-10.6-.57c3.54,0,7.08.09,10.61.2S636.21,89.61,639.73,89.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.58,85.91a29.75,29.75,0,0,1,5.65,3.53,26.64,26.64,0,0,1-2.92-1.6A28.63,28.63,0,0,1,621.58,85.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.85,89.57A32.47,32.47,0,0,1,625,93.35a32.47,32.47,0,0,1,5.88-3.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.88,87.62a7.24,7.24,0,0,1,2.58,2.08,6.85,6.85,0,0,1-1.41-.89A7.32,7.32,0,0,1,631.88,87.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.23,109.55c2.13,2.74,7.6,2.08,12.41-2.9S641,94.18,641,94.18s-7.88.6-13.89,4S619.09,106.8,621.23,109.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641,94.18c-2.88,2-5.68,4.22-8.49,6.37s-5.56,4.37-8.25,6.66c2.88-2,5.68-4.21,8.48-6.36S638.27,96.48,641,94.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.58,108a28.53,28.53,0,0,0,1.43-3,26.73,26.73,0,0,0,1.08-3.16,27.77,27.77,0,0,0-1.43,3A28.52,28.52,0,0,0,628.58,108Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634,99.64a33.06,33.06,0,0,0-7,.37,29.2,29.2,0,0,0,3.5,0A31.11,31.11,0,0,0,634,99.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.93,100.63a7.15,7.15,0,0,0,.62-1.56,7.48,7.48,0,0,0,.26-1.65,7.45,7.45,0,0,0-.88,3.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.32,92.16a3,3,0,1,1,1.93-3.77A3,3,0,0,1,640.32,92.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.16,97.87a3,3,0,1,1,1.93-3.78A3,3,0,0,1,642.16,97.87Z",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData3);
export default __webpack_public_path__ + "static/media/noData3.30099da4b3c67b06ed4129ec21d5fbff.svg";
export { ForwardRef as ReactComponent };